import { HTTPService } from './httpService';

const API = new HTTPService();

const FavoritesAPI = {
  /**
   * Toggle a favorite on/off
   * @returns {{ favorited: boolean }}
   */
  toggle: async (userId, entityType, entityId) => {
    const { data } = await API.post('/api/favorites/toggle', {
      userId, entityType, entityId
    });
    return data.data;
  },

  /**
   * Bulk check which entity IDs are favorited
   * @returns {number[]} Array of favorited entity IDs
   */
  check: async (userId, entityType, entityIds) => {
    if (!entityIds || entityIds.length === 0) return [];
    const { data } = await API.post('/api/favorites/check', {
      userId, entityType, entityIds
    });
    return data.data || [];
  },

  /**
   * Get all favorited IDs for a given entity type
   * @returns {number[]}
   */
  getAll: async (userId, entityType) => {
    const { data } = await API.get(`/api/favorites/${entityType}?userId=${userId}`);
    return data.data || [];
  }
};

export default FavoritesAPI;
